import { bboxOverlaps, boundingBox, groupRings, isPointInRing, ringLength } from './geometry';
import { effectiveCutoutMeasures, netHoleArea } from './measurement';
import { rehomeOrphanedCutouts, toPersisted } from './persistence';
import { classifyCutoutPlacement } from './placement';
import { clipHolesToRing, subtractRegions } from './subtract';

export { clippingEngineName, setClippingEngine, setClippingErrorReporter } from './engine';
export type { ClippingEngine, ClippingErrorReporter, ClippingOperation } from './engine';

/**
 * Cut-out (opening) geometry for whole-house take-off layers.
 *
 * Polygon boolean operations sit behind the port in `./engine`, whose adapter is
 * the only file in the repo permitted to import a clipping library. Everything
 * else — here and outside — goes through the facade below, so the library stays
 * swappable and every call is guarded against the throws all of them exhibit.
 *
 * A layer stores outer boundary rings in `paths` and openings in `cutouts`, as
 * flat sibling arrays. Parent attribution (which outer ring encloses which
 * opening) is DERIVED here rather than stored, because indices into `paths` do
 * not survive split, merge, extract or undo.
 */
export const cutoutUtils = {
	classifyCutoutPlacement,
	groupRings,
	netHoleArea,
	clipHolesToRing,
	effectiveCutoutMeasures,
	rehomeOrphanedCutouts,
	ringLength,
	subtractRegions,
	toPersisted,

	// Exposed for callers that need the same containment/overlap semantics.
	boundingBox,
	bboxOverlaps,
	isPointInRing,
};

export type { CutoutPlacementReason, CutoutPlacementResult } from './placement';
export type { BBox, CutterReason, CutterResult, Ring, RingSet, SubtractResult } from './types';
